import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ArticleSlider extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get header() {
    return get(this, '_header.value', '');
  }

  get articleSlides() {
    return get(this, '_article_slides', []);
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }

  get id() {
    return get(this, 'system.id', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ArticleSlider.model.js